import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'instanciaLetraCesion',
  type: 'node--instancia_letra_cesion',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    valor: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'valor_letra',
    },
    valorCesion: {
      type: 'float',
      required: false,
      isArray: false,
      name: 'importe_en_cesion',
    },
  },
  relationships: {
    letraOperation: {
      type: 'node--instancia_letra',
      required: false,
      isArray: false,
      name: 'letra_operacion',
    },
  },
};

export const InstanciaLetraCesionService = createService(base, configuration, API_CONFIG.API);
export const InstanciaLetraCesionModule = createModule(InstanciaLetraCesionService, true);



// WEBPACK FOOTER //
// ./src/models/instanciaLetraCesion.js